import { Prisma } from "@prisma/client";
import { fileSelectValues } from "../file.types";

export const customCalendarModelValues = [
  "verticalDayHour",
  "verticalDayList",
  "verticalWeekly",
  "horizontalMonthly",
  "verticalByPlace",
] as const;

export type CustomCalendarModel = (typeof customCalendarModelValues)[number];

export const customCalendarTypeValues =
  Prisma.validator<Prisma.CustomCalendarDefaultArgs>()({
    include: {
      backgroundPicture: {
        select: fileSelectValues,
      },
    },
  });

export type CustomCalendarType = Prisma.CustomCalendarGetPayload<
  typeof customCalendarTypeValues
>;

export const defaultCustomCalendarTypeValues: CustomCalendarType = {
  id: "",
  eventId: "",
  model: "verticalDayHour" as const,
  opacity: 100,
  backgroundColor: "white" as const,
  fullDayColor: "orange" as const,
  polyAnimationColor: "gray" as const,
  backgroundPicture: null,
  backgroundPictureId: "",
};

export const customCalendarTemplateTypeValues =
  Prisma.validator<Prisma.CustomCalendarTemplateDefaultArgs>()({
    include: {
      backgroundPicture: {
        select: fileSelectValues,
      },
    },
  });

export type CustomCalendarTemplateType = Prisma.CustomCalendarTemplateGetPayload<
  typeof customCalendarTemplateTypeValues
>;
